<nav
    [class.drawer]="isMobile()"
    [class.open]="opened() || !isMobile()"
    [class.transitions-enabled]="transitionsEnabled()"
    class="flex flex-col h-full p-3 bg-white border-r border-gray-200 drop-shadow-lg"
>
    <div class="flex w-full space-x-2 text-gray-600 nav-link">
        <img src="assets/images/logo.svg" alt="menu-icon" />
    </div>
    <ul class="flex flex-col gap-2 py-4 text-sm">
        @for (item of menuItems(); track item.label) {
            <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: item }"></ng-container>
        }
    </ul>

    <ng-template #menuItem let-item>
        <li [class.active]="item.active" [class.has-active-child]="hasActiveChild(item)" class="sidebar-item">
            <div class="flex items-center justify-between w-full p-2 rounded-xl">
                @if (!item.children?.length) {
                    @if (item.icon) {
                        <lucide-icon class="w-6 h-6 mr-2" [img]="item.icon"></lucide-icon>
                    }
                    <a
                        [routerLink]="item.route"
                        (click)="onMenuClick(item)"
                        class="flex items-center w-full p-1 rounded sidebar-link"
                    >
                        <span>{{ item.label }}</span>
                    </a>
                    @if (item.badge && item.badge > 0) {
                        <span
                            class="flex items-center justify-center min-w-6 h-6 px-1.5 ml-auto text-xs font-bold text-white bg-primary rounded-full"
                        >
                            {{ item.badge > 9 ? "9+" : item.badge }}
                        </span>
                    }
                }
                @if (item.children?.length) {
                    @if (item.icon) {
                        <lucide-icon class="w-6 h-6 mr-2" [img]="item.icon"></lucide-icon>
                    }
                    <span
                        class="block w-full p-1 rounded cursor-pointer sidebar-link"
                        (click)="toggleAccordion(item)"
                        >{{ item.label }}</span
                    >
                    <lucide-icon
                        class="w-4 h-4 transition-transform duration-300 ease-in-out cursor-pointer"
                        (click)="toggleAccordion(item)"
                        [class.rotate-90]="item.open"
                        [img]="ChevronRight"
                    ></lucide-icon>
                }
            </div>
            @if (item.children?.length) {
                <ul class="accordion-content" [class.open]="item.open">
                    @for (child of item.children; track child.label) {
                        <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: child }"></ng-container>
                    }
                </ul>
            }
        </li>
    </ng-template>
</nav>
